import React, {useState, useMemo, useCallback} from "react";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { FormControl, FormHelperText } from "@mui/material";

// core components
import Image from "next/image.js";
import Button from "../CustomButtons/Button.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons"

// sections for this page
import ForumsBlockerModal from "../ForumsBlockerModal/ForumsBlockerModal.js";
import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// Placeholder img
import userPlaceholder from "../../public/img/no_profile.png";
import ForumsSuccessModal from "../ForumsSuccessModal/ForumsSuccessModal.js";
import ForumsLexicalEditor from "../ForumsLexical/ForumsLexicalEditor.js";
import { useForumsCommentAddRequest } from "../../request/api";
import { useTopicContext } from "../../contexts/topic";
import {useCommentContext} from "../../contexts/comment";
import {useAuthContext} from "../../contexts/auth";
import {useTopicListContext} from "../../contexts/topicList";

const useStyles = makeStyles()(styles);

function ForumsTopicAddReply(props) {
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isBlocked, setIsBlocked] = useState(false);
    const { classes, cx } = useStyles();
    const onClose = props.onClose;
    const setSuccessModalOpen = props.setSuccessModalOpen;

    const [newPost, setNewPost] = useState(`<p></p>`);


    const { auth } = useAuthContext();
    const commentContext = useCommentContext();
    const topicContext = useTopicContext();
    const topicListContext = useTopicListContext();

    const reloadData = commentContext?.reloadComments ?? topicContext?.reloadTopic ?? topicListContext?.reloadTopics;

    const {
      isMutating: isAddingReply,
      trigger: addReply,
      error: addReplyError,
    } = useForumsCommentAddRequest({ topicId: props.topic.topicId }, undefined, {
      withCredentials: true,
    });

    const handleSubmit = async (event) => {
      console.log("check newPost type", newPost);
      event.preventDefault();
      setIsSubmitting(true);
      setSuccessModalOpen(false);
      setErrors({});

      try {
        const res = await addReply({
          body: { content: newPost, comment_id: props.topic.commentId },
        }).then((res) => res.data);

        window.gtag && window.gtag("event", "forum_topic_comment_submit");

        if (res?.success) {
          if (res?.status === "unapproved") {
            setIsBlocked(true);
            setIsSubmitting(false);
          } else {
            reloadData();
            onClose();
            setSuccessModalOpen(true);
          }
        }
      } catch (e) {
        console.error(e);
        setErrors(e.response?.data?.errors);
      } finally {
        setIsSubmitting(false);
        reloadData();
      }
    };

    const handleClose = () => {
        setIsBlocked(false);
        reloadData();
        onClose();
    };

    return (
      <>
        <form className={classes.topicCard} onSubmit={handleSubmit}>
            <div className={classes.topicUserHeader}>
                <div className={classes.topicUserInfo}>
                    <Image className={classes.userProfilePic} src={ auth.user?.image || userPlaceholder} alt={"user-profile-image"} width={30} height={30} />
                    <p className={classes.userName}>{auth.user?.username}</p>
                    <FontAwesomeIcon icon={faCircle} className={classes.userStatus} />
                </div>
            </div>
            <FormControl fullWidth>
                <ForumsLexicalEditor newPost={newPost} setNewPost={setNewPost} />
                <FormHelperText>{errors?.content}</FormHelperText>
                <div className={classes.editorButtons}>
                    <Button type="submit" className={cx(classes.darkButton + " " + classes.mediumButton + " " + classes.submitButton)}>
                      {isSubmitting ? <>
                        Submitting
                      </> : <>
                        Submit
                      </>}
                    </Button>
                    <Button className={classes.cancelButton} onClick={() => onClose()}>Cancel</Button>
                </div>
            </FormControl>
        </form>
        <ForumsBlockerModal type="language" open={isBlocked} onClose={handleClose} />
        </>
    )
}

export default function ForumsTopicAddReplyWrapper(props) {
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const { onClose, topic, community, open, ...rest } = props;
  const question = topic?.topicTitle;

  const handleSuccessClose = () => {
    setSuccessModalOpen(false);
    onClose();
  }

  return (<>
    {!!open &&
      <ForumsTopicAddReply topic={topic} open={true} onClose={onClose} setSuccessModalOpen={setSuccessModalOpen} community={community} {...rest} />
    }
    <ForumsSuccessModal open={successModalOpen} onClose={handleSuccessClose} type="reply" question={question} community={community} />
  </>);
};